import {observer} from "mobx-react";
import {
    Container, ContainerInfo, ContainerPayment, ContainerPaymentInfo,
    Content,
} from "@dropDesk/presentation/pages/subscription/ui/modals/pay_info/styled";
import HeaderModal from "@dropDesk/presentation/components/headers/header_modal";
import React, {useEffect} from "react";
import {useBetween} from "use-between";
import {useModalsSubscription} from "@dropDesk/presentation/pages/subscription/ui/modals/visible_modal_subscription";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {PaymentSubscriptionEntity} from "@dropDesk/domain/entities/payment_subscriptions/payment_subscription_entity";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {PaymentEntity} from "@dropDesk/domain/entities/payment/payment.entity";
import DividerDropDesk from "@dropDesk/presentation/components/divider";
import InputPaymentInfo from "@dropDesk/presentation/pages/subscription/ui/modals/pay_info/input_payment_info";
import CopyAndPastePix from "@dropDesk/presentation/pages/subscription/ui/modals/pay_info/copy_and_paste";
import InfoMessage from "@dropDesk/presentation/pages/subscription/ui/modals/pay_info/info_message";
import ResumeQrCode from "@dropDesk/presentation/pages/subscription/ui/modals/pay_info/qr_code";
import ButtonsInvoice from "@dropDesk/presentation/pages/subscription/ui/modals/pay_info/buttons_invoice";
import ContentInfoDisconnectedSubscription
    from "@dropDesk/presentation/components/content_info_disconnected_subscription";

const PayInfo = observer(
    ({
         payment,
         labelNewPeriod,
         disposePaymentSubscription,
         onClickDownloadInvoice,
         isPix,
         hasErrorConnectSocket,
         hasErrorConnectSocketTemporary,
         handleReconnectSocket,
         loadingReconnect,
     }: {
        payment: PaymentEntity;
        labelNewPeriod: string
        disposePaymentSubscription: () => void
        onClickDownloadInvoice: (payment: PaymentEntity) => void
        isPix: boolean
        hasErrorConnectSocket: boolean
        hasErrorConnectSocketTemporary: boolean
        loadingReconnect: boolean
        handleReconnectSocket: (payment: PaymentEntity) => void
    }) => {

        useEffect(() => {
            return () => {
                disposePaymentSubscription();
            }
        }, []);

        const appController = useInjection(AppController);
        const colors = appController.theme.colorScheme;

        const {
            setVisibleModalDisplayDataPix, setVisibleModalDisplayBoleto
        } = useBetween(useModalsSubscription);


        return (
            <Container>
                <HeaderModal
                    disabled={false}
                    letter={'Concluir pagamento'}
                    nameIcon={ICONS_DROPDESK.close}
                    onClick={() => {
                        setVisibleModalDisplayDataPix({visible: false});
                        setVisibleModalDisplayBoleto({visible: false});
                    }}
                />
                <Content background={colors.onBackground}>
                    <DividerDropDesk/>
                    <ContainerPaymentInfo>

                        <ContainerInfo>
                            {(hasErrorConnectSocket || hasErrorConnectSocketTemporary) &&
                                <ContentInfoDisconnectedSubscription
                                    loading={loadingReconnect}
                                    onClickReconnect={() => handleReconnectSocket(payment)}
                                    visibleTemporaryInformation={hasErrorConnectSocketTemporary}
                                />
                            }
                            <InputPaymentInfo
                                payment={payment}
                                labelNewPeriod={labelNewPeriod}
                            />
                            {isPix && payment.pix?.qrcodeText &&
                                <CopyAndPastePix qrcodeText={payment.pix.qrcodeText} isPix={isPix}/>
                            }

                            {!isPix &&
                                payment.boleto?.digitableLine &&
                                payment.boleto?.document &&
                                payment.pix?.qrcodeText &&
                                <ButtonsInvoice
                                    digitableLine={payment.boleto.digitableLine}
                                    onClickDownloadInvoice={() => {
                                        onClickDownloadInvoice(payment);
                                    }}
                                    inverse={true}
                                />
                            }
                            <InfoMessage
                                text={!isPix ? payment.messageTimeProcessPaymentBoleto :
                                    payment.messageTimeProcessPaymentPix}/>
                        </ContainerInfo>
                        <ContainerPayment>
                            <ResumeQrCode
                                qrCode={payment.pix?.qrcode}
                                qrCodeText={!isPix ? payment.pix?.qrcodeText : undefined}
                            />
                        </ContainerPayment>
                    </ContainerPaymentInfo>
                </Content>
            </Container>
        )
    })
export default PayInfo;
